import { render, staticRenderFns } from "./AdminProdPath.vue?vue&type=template&id=6ed70346&scoped=true&"
import script from "./AdminProdPath.vue?vue&type=script&lang=js&"
export * from "./AdminProdPath.vue?vue&type=script&lang=js&"
import style0 from "./AdminProdPath.vue?vue&type=style&index=0&id=6ed70346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed70346",
  null
  
)

export default component.exports